module.exports = __webpack_public_path__ + "static/img/a2.5fc108e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a2.png
// module id = geo/
// module chunks = 0